module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "a-personal-note-on-our-story"
    }
  }, [_c('h1', [_vm._v("A Personal Note on Our Story")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "width": "3.41597in",
      "height": "1.98403in"
    },
    attrs: {
      "alt": "C:\\Users\\Am\\Pictures\\PIC\\2.jpg",
      "src": "Images/file2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("C:\\Users\\Am\\Pictures\\PIC\\2.jpg")])]), _vm._v(" "), _c('p', [_vm._v("This journey we took let us be part of a rural French community for the three months we rented a villa in Aubusson. I wrote a diary most days. I covered the events and people and places and surprises we came across in a totally unfamiliar country and with totally different people to ourselves – the rural French. We also visited a lot of places outside of Aubusson, and in this book I have given the reader an idea of how and where and when to visit this wonderful town. It is in the Creuse department of the Limousin region – about the middle of France.")]), _vm._v(" "), _c('p', [_vm._v("****")]), _vm._v(" "), _c('p', [_vm._v("We interacted a great deal with the English who have come to live here and re-built and re-claimed the old barns, making them into somewhat amazing homes.")]), _vm._v(" "), _c('p', [_vm._v("It was like we were transported into a new world which was incomprehensible to us when we planned our holiday. We suddenly were part of this town and its towns-folk and we changed their lives by our presence. I say this, as on a day-to-day basis, we were willingly made part of their lives within a week of our arrival. What an experience … so we went back a second time!")]), _vm._v(" "), _c('p', [_vm._v("I have included a lot of history of the area and its major points of interest, which I typed from brochures. This includes the history of tapestry, the terrible German massacre in Oradour-Sur-Glane in World War Two, and the details of the Limousin region – in which Aubusson is located.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "width": "3.54375in",
      "height": "1.66389in"
    },
    attrs: {
      "alt": "C:\\Users\\Am\\Pictures\\PIC\\3.jpg",
      "src": "Images/file3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("C:\\Users\\Am\\Pictures\\PIC\\3.jpg")])]), _vm._v(" "), _c('p', [_vm._v("by Margaret Rees-Gow")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c19f523c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch007.vue
// module id = 81
// module chunks = 0